<template>
  <div>
    <Loader />
    <section class="sign-in-page">
      <div id="container-inside">
        <div class="cube"></div>
        <div class="cube"></div>
        <div class="cube"></div>
        <div class="cube"></div>
        <div class="cube"></div>
      </div>
      <b-container class="p-0">
        <b-row class="no-gutters height-self-center">
          <b-col sm="12" class="align-self-center rounded">
            <b-row class="m-0">
              <b-col md="5" class="bg-white sign-in-page-data">
                <div class="sign-in-from">
                  <router-view></router-view>
                </div>
              </b-col>
              <b-col md="7" class="text-center sign-in-page-image bg-primary">
                <div class="sign-in-detail text-white pt-5 mt-3">
                  <Slick :option="slickOptions">
                    <div class="item">
                      <img
                        :src="require('../../assets/images/login/login-3.png')"
                        class="img-fluid mb-4"
                        alt="logo"
                      />
                      <h4 class="mb-1 text-white">{{ this.$store.getters['Setting/pageTitle'] }}</h4>
                      <p>Nhanh chóng - Tiện lợi - An toàn</p>
                    </div>
                    <div class="item">
                      <img
                        :src="require('../../assets/images/login/login-3.png')"
                        class="img-fluid mb-4"
                        alt="logo"
                      />
                      <h4 class="mb-1 text-white">{{ this.$store.getters['Setting/pageTitle'] }}</h4>
                      <p>Nhanh chóng - Tiện lợi - An toàn</p>
                    </div>
                  </Slick>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<style>
#container-inside{
  overflow: hidden;
}
</style>
<script>
import Loader from '../../components/findash/loader/Loader'
import logo from '../../assets/images/logo-white.png'
import { findash } from '../../config/pluginInit'
import bgImage from '../../assets/images/login/login-2.jpg'
export default {
  name: 'AuthLayout1',
  components: {
    Loader
  },
  mounted () {
    findash.index()
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: false
      },
      logo: logo,
      bgImageURL: bgImage
    }
  }
}
</script>
